import './index.scss'
// import { useEffect } from 'react';
// import TagCloud from 'react3dtagcloud';

const RevolvingText = () => {

    // useEffect(() => {
        const TagCloud = require('TagCloud')

        const container = '.tagcloud';
        const texts = [
            'HTML 5', 'CSS 3', 'JAVASCRIPT',
            'REACT JS', 'RUST', 'NODE JS',
            'FLASK', 'FLUTTER', 'SOLANA',
            'FIREBASE', 'DART', 'RUBY',
            'SOLIDITY', 'WEB 3.0', 'PYTHON 3',
            'JAVA', 'C++', 'C', 'BLOCKCHAIN', 'COMPUTER VISION',
            'ANDROID STUDIO', 'SQLite3'
        ];
        const options = {"radius": 275};

        TagCloud(container, texts, options);
    // }, []);

    return(
        <div className="tagcloud">
            {/* <TagCloud tagName={texts} radius={200}></TagCloud> */}
        </div>
    );
}

export default RevolvingText;